// Modules
import React from "react";
import PropTypes from "prop-types";

const FilterIcon = (props) => {
	const {
		clssName,
		onClick,
	} = props;

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg" 
			x="0px"
			y="0px"
			viewBox="0 0 407 367"
			className={clssName}
			onClick={onClick}
		>
			<g>
				<path d="M379.3,39.2H150.8c-6.3-18.7-23.9-32.1-44.7-32.1S67.8,20.6,61.5,39.2H25.8c-8.3,0-15,6.7-15,15s6.7,15,15,15 h35.7c6.3,18.7,23.9,32.1,44.7,32.1s38.4-13.5,44.7-32.1h228.5c8.3,0,15-6.7,15-15S387.6,39.2,379.3,39.2z"/>
				<path d="M379.3,167.8h-35.7c-6.3-18.7-23.9-32.1-44.7-32.1s-38.4,13.5-44.7,32.1H25.8c-8.3,0-15,6.7-15,15 s6.7,15,15,15h228.5c6.3,18.7,23.9,32.1,44.7,32.1s38.4-13.5,44.7-32.1h35.7c8.3,0,15-6.7,15-15S387.6,167.8,379.3,167.8z"/>
				<path d="M379.3,296.3H215.1c-6.3-18.7-23.9-32.1-44.7-32.1s-38.4,13.5-44.7,32.1H25.8c-8.3,0-15,6.7-15,15 s6.7,15,15,15h99.9c6.3,18.7,23.9,32.1,44.7,32.1s38.4-13.5,44.7-32.1h164.2c8.3,0,15-6.7,15-15S387.6,296.3,379.3,296.3z"/>
			</g>
		</svg>
	);
};

FilterIcon.propTypes = {
	clssName: PropTypes.string,
	onClick: PropTypes.func,
};

FilterIcon.defaultProps = {
	clssName: "",
	onClick: () => {},
};

export default FilterIcon;
